module.exports = __webpack_public_path__ + "img/join1.2d4814e8.png";